import React from 'react';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { AttachmentViewerProvider } from '@lifeomic/phc-web-toolkit/src/components/Messaging/AttachmentViewer';
import {
  useActiveProjectCohortId,
  useActiveProjectId,
} from '@lifeomic/phc-web-toolkit/src/hooks';
import useService from '@lifeomic/phc-web-toolkit/src/hooks/useService';
import SubjectSearchService from '@lifeomic/phc-web-toolkit/src/services/SubjectSearchService';
import { useAsync } from 'react-use';
import { Chat } from './Chat';

const subjectSearchService = new SubjectSearchService();

export const ChatTab = ({
  patientId,
  agentUsername,
  allowMissingPatient = false,
  userIdsOverride,
}: {
  patientId?: string;
  agentUsername: string;
  allowMissingPatient?: boolean;
  userIdsOverride?: string[];
}) => {
  const activeProjectId = useActiveProjectId();
  const activeProjectCohortId = useActiveProjectCohortId();
  const [fhirSubjectSearch] = useService(
    subjectSearchService.fhirSubjectSearch,
    {
      id: 'zori-chat-subject-lookup',
      name: 'zori-chat-subject-lookup',
      log: { start: true, success: true, error: true },
      rethrowErrors: true,
    },
  );

  const { value: patient, loading } = useAsync(async () => {
    if (!patientId || !activeProjectId) return undefined;
    const response = await fhirSubjectSearch({
      projectId: activeProjectId,
      cohort: activeProjectCohortId || undefined,
      body: {
        _id: patientId,
      },
    });
    return response?.data?.entry?.[0]?.resource;
  }, [patientId, activeProjectId, activeProjectCohortId]);

  const content = !patientId ? (
    allowMissingPatient ? (
      <Chat agentUsername={agentUsername} userIdsOverride={userIdsOverride} />
    ) : null
  ) : loading || !patient ? (
    <Box align="center" justify="center" fullHeight fullWidth>
      <DotLoader size={0} />
    </Box>
  ) : (
    <Chat
      patient={patient}
      agentUsername={agentUsername}
      userIdsOverride={userIdsOverride}
    />
  );

  return <AttachmentViewerProvider>{content}</AttachmentViewerProvider>;
};
